import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../../../api/request';
import { createFetchContext } from '../../../../../../../components/contexts/FetchContextFactory';
import { getDocuments } from '../../api';
import { TeacherAdditionalDocumentResponse } from '../../type';

interface BaseLoaderProps {
  teacherId: string;
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  TeacherAdditionalDocumentResponse,
  AxiosResultDefaultError
>();

export function useAdditionalDocumentsLoader() {
  return useFetch();
}

export const AdditionalDocumentsLoaderConsumer = FetchConsumer;

export default function AdditionalDocumentsLoader({
  teacherId,
  children,
}: BaseLoaderProps) {
  const request = useCallback(async () => {
    return getDocuments({ teacherId });
  }, [teacherId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
